import React from 'react';
import FadeIn from './FadeIn';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const TrustSignals = () => {
  const pillars = [
    {
      icon: FiIcons.FiHome,
      title: "An Exclusive Private Estate",
      desc: "Unlike sprawling coastal resorts or chaotic hotel ballrooms, Padua offers complete exclusivity. Your celebration is the only focus, offering a true European villa atmosphere tucked into the Southern California mountains."
    },
    {
      icon: FiIcons.FiSun,
      title: "Flawless Indoor-Outdoor Flow",
      desc: "Many venues force you into a tent or a disjointed canyon. Padua provides a sweeping outdoor courtyard and sunset terrace that transition seamlessly into a historic, climate-controlled indoor ballroom for dinner and dancing."
    },
    {
      icon: FiIcons.FiHeart,
      title: "Chef-Driven Hospitality",
      desc: "We believe wedding food shouldn't feel like a compromise. Our culinary team delivers an elevated, restaurant-quality dining experience tailored to your tastes, served by a concierge-level waitstaff."
    }
  ];

  return (
    <section className="py-24 md:py-32 bg-brand-ivory px-6 border-t border-brand-stone/20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <FadeIn>
            <span className="text-brand-olive uppercase tracking-[0.3em] text-[10px] font-bold mb-4 block">E-E-A-T & Trust</span>
            <h2 className="font-serif text-3xl md:text-5xl text-brand-charcoal mb-6 font-light">Why Couples Choose Padua</h2>
            <p className="font-sans text-brand-charcoal/80 text-lg leading-relaxed font-light max-w-3xl mx-auto">
              For decades, couples from Claremont, Pasadena, Los Angeles, and Orange County have chosen Padua Hills Theatre to escape the ordinary. We have built our reputation on three unwavering pillars of hospitality.
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16">
          {pillars.map((pillar, idx) => (
            <FadeIn key={idx} delay={idx * 0.15} className="flex flex-col items-center text-center">
              <div className="w-16 h-16 rounded-full bg-brand-vintage flex items-center justify-center mb-6 shadow-sm border border-brand-stone/30">
                <SafeIcon icon={pillar.icon} className="text-2xl text-brand-olive" />
              </div>
              <h3 className="font-serif text-2xl text-brand-charcoal mb-4">{pillar.title}</h3>
              <p className="font-sans text-brand-charcoal/70 leading-relaxed font-light text-sm">
                {pillar.desc}
              </p>
            </FadeIn>
          ))}
        </div>

        <FadeIn delay={0.4} className="mt-20 pt-10 border-t border-brand-stone/30 text-center">
          <p className="font-sans text-[11px] uppercase tracking-widest text-brand-charcoal/50 font-bold mb-6">
            Proudly hosting couples traveling from:
          </p>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 font-sans text-sm text-brand-charcoal/70 font-light">
            <span>Claremont</span>
            <span>•</span>
            <span>Rancho Cucamonga</span>
            <span>•</span>
            <span>Upland</span>
            <span>•</span>
            <span>Pasadena</span>
            <span>•</span>
            <span>Glendora</span>
            <span>•</span>
            <span>La Verne</span>
            <span>•</span>
            <span>Orange County</span>
            <span>•</span>
            <span>Los Angeles</span>
          </div>
        </FadeIn>
      </div>
    </section>
  );
};

export default TrustSignals;